
<div class="card mt-4">
  <h4 class="card-header">Choose property</h4>
  <div class="card-body">
    <div class="form-group has-search">
      <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
      <input type="text" name="search" [(ngModel)]="searchText" class="form-control" placeholder="Search by property name">
    </div>
    @for (property of properties | filter:searchText; track property) {
      <div (click)="loadRequestPage(property)" class="comm-div">
        <p  class="comm-p">
          @if (property.property_type == 'house') {
            <fa-icon class="l-icon" [icon]="faHouse"></fa-icon>
          }
          @if (property.property_type == 'strata') {
            <fa-icon class="l-icon" [icon]="faBuilding"></fa-icon>
          }
          {{property.name}}
          <fa-icon class="float-right" [icon]="faArrowRight"></fa-icon></p>
        </div>
      }
      <!-- <mat-list>
      <mat-list-item *ngFor="let community of communities">
        <mat-icon matListIcon>folder</mat-icon>
        <h3 matLine> {{community.name}} </h3>
        <p matLine>
          <span> {{community.country_code}} </span>
          <span class="demo-2"> -- {{community.property_type}} </span>
        </p>
      </mat-list-item>
    </mat-list> -->
  </div>
</div>
